<template>
  <div  style="width: 100%">
    <v-card-text>
      <div class="req-list">
        <div :class="'req-card '+card_style(item)" style="padding: 2px" v-longclick="() => long_click(item)"
             v-on:click="goToDetail(item,1)" v-for="item in request_items"
             :key="item.Id">
          <div>
            <div class="row ">
              <div class="col-6">
                <div
                  class="req-name"
                  v-text="item.ProductName"
                ></div>
              </div>
              <div class="col-3">
                <div v-if="item.related_products.length==0"
                     class="req-name"
                     v-text="item.Qty+' عدد '"
                ></div>
                <div v-else
                     class="req-name"
                     v-text="item.final_qty+' عدد '"
                ></div>
              </div>
              <div class="col-3">
                <div
                  v-if="item.related_products.length==0"
                  class="req-name"
                  v-text="item.SourceBranchName"
                ></div>
              </div>
            </div>
            <div v-for="rel in item.related_products" v-on:click="goToDetail(rel,0)"
                 style="background-color: rgb(200 200 200);">
              <hr>

              <v-row>

                <div class="col-6">
                  <div
                    class="req-name"
                  ></div>
                </div>
                <div class="col-3">
                  <div
                    class="req-name"
                    v-text="rel.Qty+' عدد '"
                  ></div>
                </div>
                <div class="col-3">
                  <div
                    class="req-name"
                    v-text="rel.SourceBranchName"
                  ></div>
                </div>
              </v-row>
            </div>

          </div>

        </div>
      </div>
      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_records') }}</div>
      </infinite-loading>

      <v-dialog
        v-model="product_info_dialog"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{$t('information')}}</v-card-title>
          <v-card-text>
            <v-row>
              <v-row>
                <v-col style="font-weight: bold" class="p-1">
                  <p>{{selected_product_info.ProductName}}</p>
                  <p>{{selected_product_info.SourceBranchName}}</p>
                  <p>{{$t('technicianQ')}} {{selected_product_info.TechName}}</p>
                  <p>{{$t('summaryQ')}} {{selected_product_info.ProductDesc}}</p>
                  <p>{{selected_product_info.Qty}} {{$t('numbers')}}</p>
                  <p>{{selected_product_info.RequestCode}}</p>
                  <p>{{$t('referDescriptionQ')}} {{selected_product_info.Summary}}</p>
                  <p>قیمت خرید: {{selected_product_info.PurchaseAmount}}</p>
                  <p>قیمت فروش: {{selected_product_info.SaleAmount}}</p>

                  <v-row>
                    <v-col @click="open_image(img)" v-for="img in selected_product_info.Images" cols="6"><img
                      width="100%" height="auto" :src="img"></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="product_info_dialog = false"
            >{{ $t('close') }}
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card-text>
    <v-row>
      <v-col>
        <v-btn v-on:click="go_to_finalize()" class="width-100-p" color="primary" v-if="enable_finalize">{{ $t('add_invoice') }}</v-btn>
      </v-col>
    </v-row>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        active_tab: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_statuses: [],
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_device_status();

    },

    methods: {
      get_device_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
            self.get_pre_requests();

          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      get_pre_requests($state) {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          RowCount: this.page,
          StatusId: 75,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProductRequestReferByUserId', send_data, {})
          .then(response => {
            self.request_items = []
            if (response.data.error == 0) {
              // response.data.Items = response.data.Items;
              response.data.Items.forEach(function (number) {
                if (self.request_items.filter(x => x.ProductId == number.ProductId).length == 0) {
                  if (response.data.Items.filter(x => x.ProductId == number.ProductId).length == 1) {
                    number.related_products = []
                    self.request_items.push(JSON.parse(JSON.stringify(number)))
                  } else {
                    var item = JSON.parse(JSON.stringify(number));
                    item.related_products = response.data.Items.filter(x => x.ProductId == number.ProductId);
                    var final_qty = 0;
                    for (var i = 0; i < response.data.Items.filter(x => x.ProductId == number.ProductId).length; i++) {
                      final_qty += response.data.Items.filter(x => x.ProductId == number.ProductId)[i].Qty;
                    }
                    item.final_qty = final_qty;
                    self.request_items.push(item)

                  }
                }
              })

              console.log("itemsss", self.request_items)
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item, is_parent) {
        if (this.disable_click) {
          return;
        }
        console.log("go to detail worked", item)
        if (is_parent == 1 && item.related_products != null && item.related_products.length == 0) {
          this.selected_product_info = item;
          this.product_info_dialog = true;
        }
        if (is_parent == 0) {
          this.selected_product_info = item;
          this.product_info_dialog = true;

        }

      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize() {
        var array = this.request_items.filter(x => x.selected == true);

        var finalize_items = [];
        array.forEach(function (number) {
          if (number.related_products.length == 0) {
            finalize_items.push(number);
          } else {
            number.related_products.forEach(function (number2) {
              finalize_items.push(number2);
            })
          }

        });
        console.log("array is ",finalize_items)
        localStorage.setItem('buy_orders_finalize', JSON.stringify(finalize_items));
        this.$router.push({name: 'BuyOrdersFinalize'})
      }
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
